import SectionHeading from '@/components/base/SectionHeading';
import { timelineNodes } from '@/mocks/homeData';

const railTone: Record<string, string> = {
  截图: 'bg-primary-500',
  录音: 'bg-secondary-500',
  视频: 'bg-accent-500',
  聊天记录: 'bg-primary-700',
  文件解析: 'bg-secondary-700',
};

export default function TimelineSection() {
  const latest = timelineNodes[0];

  return (
    <section id="timeline" className="w-full bg-background-100 py-16 md:py-24 scroll-mt-20">
      <div className="w-full px-4 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <SectionHeading
              eyebrow="Timeline Hammer"
              title="瓜田黑料时间线锤：每个节点都有原始出处"
              description="把散落的截图、录音与文件解析按时间重新排一遍，谁先谁后、哪句话对不上，一眼就能看出来。节点可持续补录，旧的证据不会被覆盖。"
            />

            <div className="mt-8 rounded-lg border border-primary-200 bg-background-50 p-5 md:p-6">
              <div className="flex items-center justify-between gap-3">
                <span className="text-xs tracking-[0.2em] text-primary-700">最新节点</span>
                <span className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className="ri-record-circle-line text-accent-500" />
                  实时更新中
                </span>
              </div>
              <p className="mt-4 text-base md:text-lg font-semibold text-foreground-950">
                {latest.title}
              </p>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{latest.detail}</p>
              <div className="mt-4 flex flex-wrap items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-calendar-line" />
                  {latest.date} {latest.clock}
                </span>
                <span className="px-2 py-0.5 rounded-md bg-primary-100 text-primary-800 whitespace-nowrap">
                  {latest.type}
                </span>
              </div>
            </div>

            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="#archive"
                className="px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-archive-2-line" />
                回到证据归档库
              </a>
              <a
                href="#discuss"
                className="px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 text-sm hover:bg-background-200/60 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
              >
                <i className="ri-question-answer-line" />
                去对线区补充节点
              </a>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="relative pl-6 md:pl-8">
            <span className="absolute left-[7px] md:left-[9px] top-2 bottom-2 w-px bg-background-300" />
            <div className="flex flex-col gap-5 md:gap-6">
              {timelineNodes.map((node) => (
                <article
                  key={node.id}
                  className="relative rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-5 cursor-pointer hover:border-primary-300 transition-colors"
                >
                  <span
                    className={`absolute -left-6 md:-left-8 top-6 w-3.5 h-3.5 rounded-full ring-4 ring-background-100 ${
                      railTone[node.type] ?? 'bg-primary-500'
                    }`}
                  />
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="text-sm font-semibold text-foreground-950">
                      {node.date}
                    </span>
                    <span className="text-xs text-primary-700 bg-primary-100/70 px-2 py-0.5 rounded-md whitespace-nowrap">
                      {node.clock}
                    </span>
                    <span className="text-xs text-foreground-500 px-2 py-0.5 rounded-md bg-secondary-100 whitespace-nowrap">
                      {node.type}
                    </span>
                  </div>
                  <h3 className="mt-3 text-base md:text-lg font-semibold text-foreground-950">
                    {node.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{node.detail}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}